import { ServiceCancelledNotification } from "@Light/components/dash/EnergyConsumption/ServiceCancelledNotification";
import { useAccount, useLocation } from "@Light/components/page/account";
import {
  useHeaderBackNavigate,
  useHeaderTitle,
} from "@Light/components/page/header/context";
import { Hyperlink } from "@Light/components/page/Hyperlink";
import { useScaffold } from "@Light/scaffold";
import clsx from "clsx";
import React from "react";

export type ServiceDetailsServiceDetailsProps = {};

export const ServiceDetails: React.FC<
  ServiceDetailsServiceDetailsProps
> = ({}) => {
  const scaffold = useScaffold();
  const account = useAccount();
  const location = useLocation();

  useHeaderTitle("Service details");
  useHeaderBackNavigate("/account/");

  const PageBody = scaffold.page.pageBody;
  const Divided = scaffold.page.divided;
  const DetailField = scaffold.page.detail.detailField;
  const ESIIDField = scaffold.page.detail.esiidField;
  const DetailLabel = scaffold.page.detail.detailLabel;
  return (
    <PageBody>
      <div className="flex flex-col">
        {location.final_service_date && (
          <div className="pt-4">
            <ServiceCancelledNotification />
          </div>
        )}
        <Divided className="pt-8" gap="6">
          <div className="flex flex-col gap-8">
            <DetailField label="Service address">
              <div className="flex flex-col">
                <div>
                  {location.address_1}
                  {location.address_2 ? `, ${location.address_2}` : ""}
                </div>
                <div>
                  {location.city}, {location.state} {location.postal_code}
                </div>
              </div>
            </DetailField>
            <DetailField label="Account number">
              {account.account_number}
            </DetailField>
            <ESIIDField>{location.utility_number}</ESIIDField>
          </div>
          {!location.final_service_date && (
            <div className="flex flex-col gap-6">
              <div className="flex flex-col gap-2">
                <DetailLabel>Move or cancel service</DetailLabel>
                <div
                  className={clsx(
                    "text-sm",
                    scaffold.page.colors.text.secondary,
                  )}
                >
                  Please reach out to us at{" "}
                  <Hyperlink href={`tel:${scaffold.page.supportPhone}`}>
                    {scaffold.page.supportPhone}
                  </Hyperlink>{" "}
                  to make changes to your service.
                </div>
              </div>
            </div>
          )}
        </Divided>
      </div>
    </PageBody>
  );
};
